import { Children } from "react";

const appConfig = {
    "pages": [
        {
            "path":"/dynamicPackage",
            modules: [
                {
                    module: 'DynamicPackagePage',
                    sort_index: 1,
                },
            ],
            "name":"Dynamic Package Info",
            "type":"dynamicPackagePage",
            "layout":"default",
            "seo":{
                "title":"",
                "desc":""
            }
        },
        {
            "path":"/dynamicPackageSearch",
            modules: [
                {
                    module: 'ProductFilterPackageSearchPage',
                    sort_index: 1,
                },
            ],
            "name":"Dynamic Package Search",
            "type":"searchResultPage",
            "layout":"default",
            "seo":{
                "title":"",
                "desc":""
            }
        },
        {
            seo: {
                desc: '',
                title: '',
            },
            name: 'Sports and Events Search',
            path: ['/events'],
            type: 'searchResultPage',
            layout: 'default',
            modules: [
                {
                    module: 'ProductFilterSportsAndEventsSearchPage',
                    sort_index: 1,
                },
            ],
        },
        {
            seo: {
                desc: '',
                title: '',
            },
            name: 'Sports and Events Info',
            path: ['/events/:id'],
            type: 'sportsAndEventsPage',
            layout: 'default',
            modules: [
              {
                module: 'SportsAndEventsPage',
                sort_index: 1,
              },
            ],
        },
        {
            path: '/dynamicPackageEventsSearch',
            modules: [
                {
                    module: 'ProductFilterPackageSearchPageWithEvents',
                    sort_index: 1,
                },
            ],
            name: 'Dynamic Package Search With Events',
            type: 'searchResultPage',
            layout: 'default',
            seo: {
                title: '',
                desc: '',
            },
        },
        {
            path: '/dynamicPackageEvents',
            modules: [
                {
                    module: 'DynamicPackageEventsPage',
                    sort_index: 1,
                },
            ],
            name: 'Dynamic Package Events Info',
            type: 'dynamicPackagePage',
            layout: 'default',
            seo: {
                title: '',
                desc: '',
            },
        },
        {
            "path": ["/flights-async", "/flights/dynamic-async"],
            "modules": [
                {
                    module: 'ProductFilterFlightSearchPageAsync',
                    sort_index: 1,
                },
            ],
            "name": "Flight Search Async",
            "type": "searchResultPage",
            "layout": "default",
            "seo": {
                "title": "",
                "desc": ""
            }
        },
        {
            "id": "blog-category",
            "seo": {
                "desc": "",
                "title": ""
            },
            "name": "Blog Category Page",
            "path": [
                "/blog/category/:slug"
            ],
            "type": "blogCategoryPage",
            "layout": "default",
            "modules": [
                {
                    "module": "BlogCategoryPageInstance",
                    "sort_index": 1
                }
            ]
        },
        {
            "id": "blog-post",
            "seo": {
                "desc": "",
                "title": ""
            },
            "name": "Blog Post Page",
            "path": [
                "/blog/:slug"
            ],
            "type": "BlogPostPage",
            "layout": "default",
            "modules": [
                {
                    "module": "BlogPostPageInstance",
                    "sort_index": 1
                }
            ]
        }
    ],
    "modulesConfigs": {
        "BlogCategoryPageInstance": {
            "module": "BlogCategoryPage",
        },
        "BlogPostPageInstance": {
            "module": "BlogPostPage",
        },
        DynamicPackageEventsPage: {
            theme: {
                button: 'btn-style-5',
                tertiary: 'black',
                text_color: '#fff',
                background: '#00ccff33',
            },
            PackageDetailsConfig: {
                widgetFlights: {
                    isActive: false,
                    widgetSet: 'FlightsSet2',
                },
                widgetHotelInfo: {
                    isActive: true,
                    widgetSet: 'HotelInfoSet1',
                },
                widgetActivities: {
                    theme: {
                        button: 'btn-style-5',
                        background: '#fff',
                        tertiary: '#000000',
                    },
                    isActive: true,
                    widgetSet: 'ActivitiesSet2',
                },
                showDates: false,
            },
            RoomPricingConfig: {
                set: 'RoomPricingSet1',
                theme: {
                    button: 'btn-style-5',
                    tertiary: 'black',
                    background: '#00ccff33',
                },
            },
            EventsConfig: {
                set: 'EventsSet1',
                theme: {
                    button: 'btn-style-5',
                    tertiary: 'black',
                    background: '#00ccff33',
                },
            },
        },
        ProductFilterPackageSearchPageWithEvents: {
            module: 'SwitchDatePicker',
            showFilters: {
                isActive: false,
            },
            searchOptions: ['events'],
            showSearchResults: {
                isActive: true,
            },
            isDynamicPackageSearchWithEvents: true,
        },
        ProductFilterSportsAndEventsSearchPage: {
            theme: {
                primary: '#0a2a59',
                tertiary: '#7d7f8b',
                secondary: '#53cff7',
                background: '#f2f3f5',
            },
            module: 'SwitchDatePicker',
            backgroundImg: '/assets/images/sky360/main-back.jpg',
            searchOptions: ['events'],
            showSearchResults: {
                isActive: true,
            },
        },
        "ProductFilterFlightSearchPageAsync": {
            "module": "SwitchDatePicker",
            'searchOptions': ['flights'],
            "backgroundImg": "/assets/images/sky360/main-back.jpg",
            // leave this as true, to make sure async flight always using async search
            "useAsyncSearch": true,
            "showSearchResults": {
                isActive: true
            },
            "theme": {
                "primary": "#0a2a59",
                "secondary": "#53cff7",
                'tertiary': "#7d7f8b"
            }
        },
        "DynamicPackagePage":{
            "module": "DynamicPackagePage",
            "theme":{
                "button":"btn-style-5",
                "tertiary":"black",
                "text_color":"#fff",
                "background":"#00ccff33"
            },
            "PackageDetailsConfig":{
                "widgetFlights":{
                    "isActive":false,
                    "widgetSet":"FlightsSet2"
                },
                "widgetHotelInfo":{
                    "isActive":true,
                    "widgetSet":"HotelInfoSet1"
                },
                "widgetActivities":{
                    "theme":{
                        "button":"btn-style-5",
                        "background":"#fff",
                        "tertiary":"#000000"
                    },
                    "isActive":true,
                    "widgetSet":"ActivitiesSet2"
                },
                "showDates":false
            },
            "RoomPricingConfig":{
                "set":"RoomPricingSet1",
                "theme":{
                    "button":"btn-style-5",
                    "tertiary":"black",
                    "background":"#00ccff33"
                }
            }
        }
    }
};
export default appConfig;